import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const intention = {
	chooseIdentity:(cvAccountToken, payload)=>{
		return api.post(proxyApi + '/v3/cv_accounts/'+cvAccountToken+'/identify_info',payload)
	},
	getIdentity: payload => {
		return api.get(proxyApi + '/v3/cv_accounts/' + payload.id + '/identify_info')
	},
	//修改用户求职意向（新，可修改部分内容）
	updateIntentions:payload => {
		return api.put(proxyApi + '/v4/jobs/intentions',payload)
	},
	getIntentionNew: payload => {
		return api.get(proxyApi + '/v4/jobs/intentions', payload)
	},
	/** 获取用户 学生或者职场人 的职业状态  */
	fetchJobStatusTemplate: (payload) => {
		return api.get(proxyApi + '/v3/job_status_template', payload)
	},
	/** 获取用户 已选的职业状态 */
	fetchSelectedJobStatus: (cvAccountToken) => {
		return api.get(proxyApi + '/v3/cv_accounts/' + cvAccountToken + '/job_status')
	},
	/** 更新用户的职业状态 */
	updateUserJobStatus: (cvAccountToken, payload) => {
		return api.put(proxyApi + '/v3/cv_accounts/' + cvAccountToken + '/job_status', payload)
	},
}


export default intention
